export default __webpack_public_path__ + "static/media/selfie.524e95a0.webp";